import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { appConstants } from '../../app.constants';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
})
export class FooterComponent implements OnInit {
  public aplicacao: {
    nome: string;
    versao: string;
    commitSha: string;
    dataCompilacao: string;
  };

  ngOnInit(): void {
    this.aplicacao = {
      nome: appConstants.nome,
      versao: environment.versao,
      dataCompilacao: environment.dataCompilacao,
      commitSha: environment.commitSha,
    };
  }
}
